import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: 'network',
    name: 'network',
    component: () => import('./network.vue'),
    props: true,
  },
];
